import { useCallback } from 'react';
import I18n from 'I18n';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
function MeetingNameSearchInput({
  value,
  onChange
}) {
  const handleSearchInputChange = useCallback(event => {
    onChange(event.target.value);
  }, [onChange]);
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": I18n.text('filters.searchPlaceholder'),
    children: /*#__PURE__*/_jsx(SearchInput, {
      "data-selenium-test": "meetings-search-input",
      placeholder: I18n.text('filters.searchPlaceholder'),
      value: value,
      onChange: handleSearchInputChange
    })
  });
}
export default MeetingNameSearchInput;